import { useTranslation } from 'react-i18next';
import { qcChecklistKeys } from '@/mocks/supplierNetwork';

export default function QualityControl() {
  const { t } = useTranslation('supplierNetwork');

  return (
    <section className="w-full bg-ink-800 py-12 md:py-16 lg:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 md:mb-12">
            <span className="text-xs font-semibold text-warm-500 uppercase tracking-[0.2em] mb-3 block">
              {t('qc.label')}
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
              {t('qc.title')}
            </h2>
            <p className="text-sm md:text-base text-white/60 max-w-2xl mx-auto">
              {t('qc.subtitle')}
            </p>
          </div>

          {/* Checklist */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {qcChecklistKeys.map((key, index) => (
              <div
                key={key}
                className="flex items-center gap-3 p-4 md:p-5 bg-white/5 border border-white/10 rounded-lg"
              >
                <div className="w-8 h-8 shrink-0 rounded-full bg-warm-500 flex items-center justify-center">
                  <span className="text-white text-sm font-bold">{index + 1}</span>
                </div>
                <span className="text-sm text-white/80">{t(key)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}